import { BlockList, PlacementProvider } from '@zillow/cms-blocks';
import { Box } from '@zillow/constellation-10';
import React from 'react';

import { PageTemplateProps } from './PageTemplate.types';

const PageTemplate = ({ post }: PageTemplateProps): JSX.Element => {
    return (
        <PlacementProvider placement="page">
            <BlockList blocks={post?.blocks || []} />
            {post?.footer && (
                <Box
                    css={{
                        // v8 `margin: '0 auto'` / `padding: '0 $spacing.sm'`
                        // split into logical longhands — Panda forbids the
                        // `margin`/`padding` shorthands with token values.
                        // $spacing.sm = 16px = spacing.400 = `default`.
                        marginBlock: '0',
                        marginInline: 'auto',
                        paddingBlock: '0',
                        paddingInline: 'default',
                        // v8 $breakpoints.xxl = 1281px → sizes.breakpoint-xxl
                        // = 80em = 1280px. The 1px difference is inherent to
                        // v8's max-width breakpoints being min-width minus one.
                        maxWidth: 'breakpoint-xxl',
                    }}
                >
                    <BlockList blocks={post?.footer?.blocks || []} />
                </Box>
            )}
        </PlacementProvider>
    );
};

export default PageTemplate;
